import React from 'react';

// Same structure and classes as LoginPage, so both standalone pages share a look
const ErrorPage = () => {
  return (
    <div className="error-page">
      <section className="error-message">
        <h1>Error Page</h1>
        <p>Sorry, an error occurred.</p>
      </section>

      <section className="back">
        {/* Plain link, not <Link>: this page is also the app-level ErrorBoundary fallback, which renders outside the Router */}
        <a href="/" className="button primary small">Back to Home</a>
      </section>
    </div>
  );
};

export default ErrorPage;
